import type { AppTranslations } from 'translations/translations';
import { isValidNumber } from 'utils/formValidation/validations';
import {
  findComparator,
  numberComparators,
  stringComparators,
} from './comparator';

export const getNumberFilterValueValidationErrors = (
  msg: AppTranslations,
  value: string,
): string | undefined => {
  const comparator = findComparator(value);

  if (value && comparator) {
    const clearValue = value.replace(comparator, '');

    if (!numberComparators.includes(comparator)) {
      return msg.formikFilterText.invalidFilter;
    }
    if (!clearValue) {
      return msg.formikFilterText.valueRequired;
    }
    if (!isValidNumber(clearValue)) {
      return msg.formikFilterText.valueMustBeNumber;
    }
    return undefined;
  }
  if (value && !isValidNumber(value)) {
    return msg.formikFilterText.valueMustBeNumber;
  }
  return undefined;
};

export const getStringFilterValueValidationErrors = (
  msg: AppTranslations,
  value: string,
): string | undefined => {
  const comparator = findComparator(value);

  if (value && comparator) {
    const clearValue = value.replace(comparator ?? '', '');

    if (!stringComparators.includes(comparator)) {
      return msg.formikFilterText.invalidFilter;
    }
    if (!clearValue) {
      return msg.formikFilterText.valueRequired;
    }
    return undefined;
  }
  return undefined;
};
